import { fetchResultsEnrichment } from 'api/DataEnrichment'
import Axios from 'axios'
import {
  currentParams,
  multifyParams,
  stringifyParams,
} from 'helpers/querystring'

const client = Axios.create({

  paramsSerializer(params) {
    return stringifyParams(params, { arrayFormat: 'brackets' })
  },
})

/**
 * Fetch results from the search API.
 *
 * @param {object} params - Search parameters.
 * @param {object} drupal - Drupal configuration.
 * @param {object} api_params - API parameters.
 * @param {boolean} isAppendResults - Append hits.
 * @returns {Promise} - The fetch promise.
 */
const fetchResults = (params, drupal, api_params, isAppendResults) => {
  const urlParams = currentParams()
  const searcher = drupal.niche || urlParams.searcher || 'global'
  const path = `${searcher}_${drupal.language}`
  const controller = Axios.CancelToken.source()
  const site = multifyParams(drupal.domains, 'site')
  const student_subject = drupal.node_id
  const apiUrlParams = multifyParams(api_params, 'organization_facet_tree', '|')

  const defaultSearcherParams =
    {
      global: { q: '*', sort: 'created_decending', ...site },
      news: { q: '*', sort: 'created_decending', ...site },
      research: { q: '*', sort: 'created_decending', ...site },
      event: { q: '*', sort: 'date_asc', ...site },
      person: { q: '*', sort: 'relevance', ...site },
      education: { q: '*', ...site },
      organization: { q: '*', sort: 'alphabetical', ...site },
      local_page: {
        sort: 'alphabetical',
        ...site,
        student_subject,
        ...apiUrlParams,
      },
    }[searcher] || {}

  // WK-7158 params is holding internal parameters for the local_page widget, we don't need to send those.
  if (searcher === 'local_page') {
    params = {}
  }

  // Check if hits are to be appended, or just refetched, limited by 200 hits.
  if (isAppendResults) {
    params = { ...params, hits: 10, offset: params.hits - 10 }
  } else if (params.hits > 199 ) {
    params = { ...params, hits: 200}
  }

  const fetch = client
    .get(path, {
      baseURL: drupal.endpoint,
      params: { ...defaultSearcherParams, ...params },
      searcher,
      cancelToken: controller.token,
    })
    // .then(fetchResultsEnrichment.orderFacets)
    // .then(fetchResultsEnrichment.orderFacetsItems)
    .then(fetchResultsEnrichment.orderFacetsItemsEducationPeriod)
    .then(fetchResultsEnrichment.addFacetsDataStructure)
    .then(fetchResultsEnrichment.addDocumentBreadcrumb)
    .then(fetchResultsEnrichment.addDocumentResearchTypeShort)
    .then(fetchResultsEnrichment.removeUnmappedOrganizations)
    .then(fetchResultsEnrichment.removeInvalidParams)
    .then(fetchResultsEnrichment.sortOrganizations)
    .then(fetchResultsEnrichment.normalizeHeaders)
    .then(fetchResultsEnrichment.replaceOrganizationNames)

  return [fetch, controller]
}

const fetchSuggestions = (params, drupal) => {
  const urlParams = currentParams()
  const searcher = drupal.niche || urlParams.searcher || 'global'
  const path = `${searcher}_${drupal.language}`
  const controller = Axios.CancelToken.source()
  const site = multifyParams(drupal.domains, 'site')

  const fetch = client
    .get(path, {
      baseURL: drupal.completer,
      params: { ...params, ...site },
      searcher,
      cancelToken: controller.token,
    })
    .catch((error) => {
      if (!Axios.isCancel(error)) {
        const msg = `fetchSuggestions: ${error.message}`
        console.log(msg)
        throw new Error(msg)
      }
    })

  return [fetch, controller]
}

export default {
  fetchResults,
  fetchSuggestions,
}
